import { type AuthState } from '@okta/okta-auth-js'
import User from 'types/User'

import { AuthRole } from './const'

export const initUser = (authState: AuthState, userRoles: string[]) => {
  if (authState?.accessToken) {
    const groups = authState?.accessToken?.claims.groups
    const arrayGroups: string[] = groups 
      ? Object.values(groups).map(gr => {
        return gr as string
      })
      : []

    const authRoles = userRoles && userRoles.length > 0 ? getAuthRole(userRoles) : []
    return new User(arrayGroups, authRoles)
  }
  return undefined
}

const getAuthRole = (roles: string[]): AuthRole[] => {
  const userRoles = new Set<AuthRole>()
  roles.forEach(role => {
    const authRole = AuthRole[role as keyof typeof AuthRole]
    if (authRole) userRoles.add(AuthRole[role as keyof typeof AuthRole])
  })
  return Array.from(userRoles)
}

export const hasRole = (target: AuthRole, user: User | undefined) => {
  if (!user || !user.roles || user.roles.length === 0) {
    return false
  }
  return user.canUse(target)
}
